import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LogOut } from "lucide-react";
import { SiteLayout } from "@/components/SiteLayout";
import { useI18n } from "@/lib/i18n";
import { useMember } from "@/lib/member";

export const MemberShell = ({ children }) => {
  const { t } = useI18n();
  const { member, logout } = useMember();
  const loc = useLocation();
  const tabs = [
    ["/member", t("memberDashboard")],
    ["/member/bookings", t("myBookings")],
    ["/member/addresses", t("savedAddresses")],
    ["/member/profile", t("myProfile")],
  ];
  return (
    <SiteLayout>
      <div className="mx-auto max-w-4xl px-5 py-12" data-testid="member-area">
        <div className="flex items-center gap-4">
          {member?.picture
            ? <img src={member.picture} alt="" className="h-12 w-12 rounded-full object-cover" />
            : <div className="h-12 w-12 rounded-full bg-ink text-cream grid place-items-center font-display">
                {(member?.name || member?.email || "?").slice(0, 1).toUpperCase()}
              </div>}
          <div className="min-w-0">
            <div className="font-display text-2xl tracking-tight truncate" data-testid="member-name">
              {t("welcome").replace("{name}", member?.name || member?.email || "")}
            </div>
            <div className="text-xs text-ink-soft truncate">{member?.email}</div>
          </div>
          <button data-testid="member-logout" onClick={logout}
            className="ml-auto text-xs text-ink-soft hover:text-lm-red flex items-center gap-1.5">
            <LogOut size={14} /> {t("logout")}
          </button>
        </div>

        <nav className="mt-8 flex gap-1 overflow-x-auto border-b border-black/10">
          {tabs.map(([to, label]) => (
            <Link key={to} to={to} data-testid={`member-tab-${to.split("/")[2] || "home"}`}
              className={`px-4 py-2.5 text-sm whitespace-nowrap border-b-2 -mb-px transition-colors ${
                loc.pathname === to ? "border-lm-red text-lm-red" : "border-transparent text-ink-soft hover:text-ink"}`}>
              {label}
            </Link>
          ))}
        </nav>
        <div className="mt-8">{children}</div>
      </div>
    </SiteLayout>
  );
};
